import React, { useEffect, useState } from "react";
import { withRouter, useHistory } from "react-router";
import axios from 'axios'
import './Sing.css'
import { pokemonType } from '../style';
import { TypesData } from "./TypesData";
import { Nav2, Navbtn, Search2 } from "../MainElements/NavbarElements";
import poke from "./pok1.png"

const SinglePokemon = ({ match}) =>{
const [typ1, setTyp1] = useState(0)
const [typ2, setTyp2] = useState(0)
const [te, setTe] = useState(false)
const history = useHistory()
const [pokemon, setPokemon] = useState({
          name: "", 
          species: "", 
          img: "",
          type1: "",
          type2: "",
})

  const searchPokemon = () => {
    axios.get(`https://pokeapi.co/api/v2/pokemon/${match.params.id}`).then(
      (response) =>{
        switch(response.data.types[0].type.name){
          case "normal":
             setTyp1(1);
             break;
          case "fighting":
            setTyp1(2);
            break;
          case "flyin":
            setTyp1(3);
            break;
            case "poison":
            setTyp1(4);
            break;
            case "ground":
            setTyp1(5);
            break;
            case "rock":
            setTyp1(6);
            break;
            case "bug":
            setTyp1(7);
            break;
            case "ghost":
            setTyp1(8);
            break;
            case "steel":
            setTyp1(9);
            break;
            case "fire":
            setTyp1(10);
            break;
            case "water":
            setTyp1(11);
            break;
            case "grass":
            setTyp1(12);
            break;
            case "electric":
            setTyp1(13);
            break;
            case "psychic":
            setTyp1(14);
            break;
            case "ice":
            setTyp1(15);
            break;
            case "dragon":
            setTyp1(16);
            break;
            case "dark":
            setTyp1(17);
            break;
            case "fairy":
            setTyp1(18);
            break;
         }
        if (!response.data.types[1]){
        setPokemon({
          name: response.data.name, 
          species: response.data.species.name, 
          type1c: response.data.types[0].type.name,
          type1: response.data.types[0].type.name.charAt(0).toUpperCase() + response.data.types[0].type.name.slice(1),
          num: response.data.id.toString().padStart(3, '0'),
          height: response.data.height,
          weight: response.data.weight,
        }); 
        
      }else{
        setTe(true)
        switch(response.data.types[1].type.name){
          case "normal":
             setTyp2(1);
             break;
          case "fighting":
            setTyp2(2);
            break;
          case "flying":
            setTyp2(3);
            break;
            case "poison":
            setTyp2(4);
            break;
            case "ground":
            setTyp2(5);
            break;
            case "rock":
            setTyp2(6);
            break;
            case "bug":
            setTyp2(7);
            break;
            case "ghost":
            setTyp2(8);
            break;
            case "steel":
            setTyp2(9);
            break;
            case "fire":
            setTyp2(10);
            break;
            case "water":
            setTyp2(11);
            break;
            case "grass":
            setTyp2(12);
            break;
            case "electric":
            setTyp2(13);
            break;
            case "psychic":
            setTyp2(14);
            break;
            case "ice":
            setTyp2(15);
            break;
            case "dragon":
            setTyp2(16);
            break;
            case "dark":
            setTyp2(17);
            break;
            case "fairy":
            setTyp2(18);
            break;
         }
        setPokemon({
          name: response.data.name, 
          species: response.data.species.name, 
          type1c: response.data.types[0].type.name,
          type1: response.data.types[0].type.name.charAt(0).toUpperCase() + response.data.types[0].type.name.slice(1),
          type2c: response.data.types[1].type.name,
          type2: response.data.types[1].type.name.charAt(0).toUpperCase() + response.data.types[1].type.name.slice(1),
          num: response.data.id.toString().padStart(3, '0'), 
          height: response.data.height,
          weight: response.data.weight,
        });
      }
      }
    )    
  }
  
  useEffect(()=>{
    searchPokemon()
  },[])

  const toHome = ()=>{
    history.replace({pathname:`/`})
  }
  const t1= TypesData[typ1].a* TypesData[typ2].a/100
  const t2= TypesData[typ1].b* TypesData[typ2].b/100
  const t3= TypesData[typ1].c* TypesData[typ2].c/100
  const t4= TypesData[typ1].d* TypesData[typ2].d/100
  const t5= TypesData[typ1].e* TypesData[typ2].e/100
  const t6= TypesData[typ1].f* TypesData[typ2].f/100
  const t7= TypesData[typ1].g* TypesData[typ2].g/100
  const t8= TypesData[typ1].h* TypesData[typ2].h/100
  const t9= TypesData[typ1].i* TypesData[typ2].i/100
  const t10= TypesData[typ1].j* TypesData[typ2].j/100
  const t11= TypesData[typ1].k* TypesData[typ2].k/100
  const t12= TypesData[typ1].l* TypesData[typ2].l/100
  const t13= TypesData[typ1].m* TypesData[typ2].m/100
  const t14= TypesData[typ1].n* TypesData[typ2].n/100
  const t15= TypesData[typ1].o* TypesData[typ2].o/100
  const t16= TypesData[typ1].p* TypesData[typ2].p/100
  const t17= TypesData[typ1].q* TypesData[typ2].q/100
  const t18= TypesData[typ1].r* TypesData[typ2].r/100
  const hei = pokemon.height/10
  const wei = pokemon.weight/10
  return <Search2>
    <Nav2>
    <Navbtn onClick={toHome}>Go back</Navbtn>
    </Nav2>
    <div className="Sing_bg">
    <div className="col-1">
    <div className="Sing_top">
    <h1 className='Top_1'>#{pokemon.num}</h1>
    <h1 className='Top_1'>{pokemon.name.charAt(0).toUpperCase() + pokemon.name.slice(1)}</h1>
    </div>
    <div className="Sing_top">
    <div className='Sing_types'>
    <h3 className='Sing_type' 
   style={{backgroundColor:pokemonType[pokemon.type1c]}}>
     {pokemon.type1}</h3>
    {te && <h3 className='Sing_type' 
   style={{backgroundColor:pokemonType[pokemon.type2c]}}>
     {pokemon.type2}</h3>}
     </div>
     
     </div>
    <img className="Sing_img" src={"https://assets.pokemon.com/assets/cms2/img/pokedex/full/"+pokemon.num+".png"} />
    <div className="Sing_stat">
    <h3 className="stats">height: {hei}m</h3>
    <h3 className="stats">weight: {wei}kg</h3>
    </div>
    </div>
    <div className="col-2">
     <h3 className="typ_title"><div className="typ_b" >Weakness</div></h3>
     <h5 className="typ" ><div className="typ_b"><div className="typ_t" style={{backgroundColor:pokemonType["normal"]}}>Normal</div></div><div style={{backgroundColor:pokemonType["normal"]}} className="typ_n">{t1}</div></h5>
     <h5 className="typ" ><div className="typ_b"><div className="typ_t" style={{backgroundColor:pokemonType["fighting"]}}>Fighting</div></div><div style={{backgroundColor:pokemonType["fighting"]}} className="typ_n">{t2}</div></h5>
     <h5 className="typ" ><div className="typ_b"><div className="typ_t" style={{backgroundColor:pokemonType["flying"]}}>Flying</div></div><div style={{backgroundColor:pokemonType["flying"]}} className="typ_n">{t3}</div></h5>
     <h5 className="typ" ><div className="typ_b"><div className="typ_t" style={{backgroundColor:pokemonType["poison"]}}>Poison</div></div><div style={{backgroundColor:pokemonType["poison"]}} className="typ_n">{t4}</div></h5>
     <h5 className="typ" ><div className="typ_b"><div className="typ_t" style={{backgroundColor:pokemonType["ground"]}}>Ground</div></div><div style={{backgroundColor:pokemonType["ground"]}} className="typ_n">{t5}</div></h5>
     <h5 className="typ" ><div className="typ_b"><div className="typ_t" style={{backgroundColor:pokemonType["rock"]}}>Rock</div></div><div style={{backgroundColor:pokemonType["rock"]}} className="typ_n">{t6}</div></h5>
     <h5 className="typ" ><div className="typ_b"><div className="typ_t" style={{backgroundColor:pokemonType["bug"]}}>Bug</div></div><div style={{backgroundColor:pokemonType["bug"]}} className="typ_n">{t7}</div></h5>
     <h5 className="typ" ><div className="typ_b"><div className="typ_t" style={{backgroundColor:pokemonType["ghost"]}}>Ghost</div></div><div style={{backgroundColor:pokemonType["ghost"]}} className="typ_n">{t8}</div></h5>
     <h5 className="typ" ><div className="typ_b"><div className="typ_t" style={{backgroundColor:pokemonType["steel"]}}>Steel</div></div><div style={{backgroundColor:pokemonType["steel"]}} className="typ_n">{t9}</div></h5>
     <h5 className="typ" ><div className="typ_b"><div className="typ_t" style={{backgroundColor:pokemonType["fire"]}}>Fire</div></div><div style={{backgroundColor:pokemonType["fire"]}} className="typ_n">{t10}</div></h5>
     <h5 className="typ" ><div className="typ_b"><div className="typ_t" style={{backgroundColor:pokemonType["water"]}}>Water</div></div><div style={{backgroundColor:pokemonType["water"]}} className="typ_n">{t11}</div></h5>
     <h5 className="typ" ><div className="typ_b"><div className="typ_t" style={{backgroundColor:pokemonType["grass"]}}>Grass</div></div><div style={{backgroundColor:pokemonType["grass"]}} className="typ_n">{t12}</div></h5>
     <h5 className="typ" ><div className="typ_b"><div className="typ_t" style={{backgroundColor:pokemonType["electric"]}}>Electric</div></div><div style={{backgroundColor:pokemonType["electric"]}} className="typ_n">{t13}</div></h5>
     <h5 className="typ" ><div className="typ_b"><div className="typ_t" style={{backgroundColor:pokemonType["psychic"]}}>Psychic</div></div><div style={{backgroundColor:pokemonType["psychic"]}} className="typ_n">{t14}</div></h5>
     <h5 className="typ" ><div className="typ_b"><div className="typ_t" style={{backgroundColor:pokemonType["ice"]}}>Ice</div></div><div style={{backgroundColor:pokemonType["ice"]}} className="typ_n">{t15}</div></h5>
     <h5 className="typ" ><div className="typ_b"><div className="typ_t" style={{backgroundColor:pokemonType["dragon"]}}>Dragon</div></div><div style={{backgroundColor:pokemonType["dragon"]}} className="typ_n">{t16}</div></h5>
     <h5 className="typ" ><div className="typ_b"><div className="typ_t" style={{backgroundColor:pokemonType["dark"]}}>Dark</div></div><div style={{backgroundColor:pokemonType["dark"]}} className="typ_n">{t17}</div></h5>
     <h5 className="typ" ><div className="typ_b"><div className="typ_t" style={{backgroundColor:pokemonType["fairy"]}}>Fairy</div></div><div style={{backgroundColor:pokemonType["fairy"]}} className="typ_n">{t18}</div></h5>
     <div className="imgl"><img className="min" src={poke}></img></div>
     </div>
     </div> 
  </Search2>
}

export default withRouter(SinglePokemon)